import { BookOpen, Headphones, NotebookPen, Mic } from './Icons';

export const subjects = [
  {
    id: 'reading',
    title: '阅读',
    english: 'Reading',
    image: 'reading',
    icon: BookOpen,
    desc: '读懂文字，也读懂言外之意。',
  },
  {
    id: 'use_of_english',
    title: '英语运用',
    english: 'Use of English',
    image: 'reading',
    icon: NotebookPen,
    desc: '掌握词汇、语法和句型转换。',
  },
  {
    id: 'reading-use',
    title: '阅读与英语运用',
    english: 'Reading',
    image: 'reading',
    icon: BookOpen,
    desc: '读懂文字，也读懂言外之意。',
  },
  {
    id: 'listening',
    title: '听力',
    english: 'Listening',
    image: 'listening',
    icon: Headphones,
    desc: '捕捉每一句话里的关键信息。',
  },
  {
    id: 'writing',
    title: '写作',
    english: 'Writing',
    image: 'writing',
    icon: NotebookPen,
    desc: '让你的想法，清晰落在纸上。',
  },
  {
    id: 'speaking',
    title: '口语',
    english: 'Speaking',
    image: 'speaking',
    icon: Mic,
    desc: '开口表达，让交流更进一步。',
  },
] as const;

export function SubjectArt({ section, className = '' }: { section: string; className?: string }) {
  const subject = subjects.find((s) => s.id === section) ?? subjects[0];
  return (
    <img
      className={'subject-art ' + className}
      src={'/brand/' + subject.image + '.webp'}
      width="256"
      height="256"
      alt=""
      aria-hidden="true"
    />
  );
}

export function SubjectIcon({ section, size = 22 }: { section: string; size?: number }) {
  const Icon = subjects.find((s) => s.id === section)?.icon ?? BookOpen;
  return (
    <span className={'subject-icon ' + section}>
      <Icon size={size} weight="duotone" aria-hidden="true" />
    </span>
  );
}
